import { Component, Input } from '@angular/core';
import { RouteSheetLocationDTO } from 'src/app/features/locations-map/models/RouteSheetLocationDTO';
import { RouteSheetService } from 'src/app/features/locations-map/services/RouteSheet.service';

@Component({
  selector: 'route-sheet-unit-card',
  templateUrl: './unit-card.component.html',
  styleUrls: ['./unit-card.component.css']
})
export class UnitCardComponent {
  @Input() routeSheetLocation: RouteSheetLocationDTO;
  @Input() skeletonLoading: boolean = false;
  
  constructor(private routeSheetService: RouteSheetService) {}
}
